<script>
	import { getContext } from 'svelte'
	import { styles } from '../scripts/styles.js'
	export let color = 'black'
	export let size = '4vw'
	export let info = ''
	export let width = '100vw'

	const globals = getContext('globals')
	export let fontSize = globals.fsX
	const colorMain = globals.colorMain
</script>

<div class="container" use:styles={{ width }}>
	<div use:styles={{ color, size }} id="loading" />
	<div use:styles={{ fontSize, colorMain }} class="info">{info}</div>
</div>

<style>
	.container {
		width: var(--width);
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	#loading {
		display: inline-block;
		width: var(--size);
		height: var(--size);
		border: 3px solid var(--color);
		border-radius: 50%;
		border-top-color: transparent;
		animation: spin 1s linear infinite;
		-webkit-animation: spin 1s linear infinite;
	}

	.info {
		display: flex;
		justify-content: center;
		color: var(--colorMain);
		font-size: var(--fontSize);
		margin-top: 2vh;
	}

	@keyframes spin {
		to {
			-webkit-transform: rotate(360deg);
		}
	}
	@-webkit-keyframes spin {
		to {
			-webkit-transform: rotate(360deg);
		}
	}
</style>
